import { put, takeLatest } from 'redux-saga/effects';
import { SpaceTabAPI } from 'api/space/space-tab';
import { fetchDetailStart } from 'data/space-tabs';
import { logger } from 'services';
import { fetchSpaceTabSagaAction, spaceTabSuccessSagaAction } from '../actions';
function* fetchSpaceTabSaga(action) {
    const { payload } = action;
    try {
        yield put(fetchDetailStart(payload));
        const response = yield SpaceTabAPI.getSpaceTab(payload);
        yield put(spaceTabSuccessSagaAction(response));
    } catch (error) {
        logger.error('getSpaceTab failed', {
            error
        });
    }
}
export function* watchFetchSpaceTabSaga() {
    yield takeLatest(fetchSpaceTabSagaAction.type, fetchSpaceTabSaga);
}
